import { render, staticRenderFns } from "./ReSearchScndFlatBig.vue?vue&type=template&id=22008d55&scoped=true"
import script from "./ReSearchScndFlatBig.vue?vue&type=script&lang=js"
export * from "./ReSearchScndFlatBig.vue?vue&type=script&lang=js"
import style0 from "./ReSearchScndFlatBig.vue?vue&type=style&index=0&id=22008d55&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22008d55",
  null
  
)

export default component.exports